/* In order for this mixin to work, your form needs to be built on objects:
form: {
        fullName: {
          value: contactDetailsForm.fullName,
          errors: [],
        },
        email: {
          value: contactDetailsForm.newEmail || contactDetailsForm.email,
          errors: [],
        },
        phoneNumber: {
          value: contactDetailsForm.phoneNumber,
          errors: [],
        },
      },
},
formValidation: {
  fullName: {
    [FORM_VALIDATION.REQUIRED]: 'This field is required',
    [FORM_VALIDATION.MIN_LENGTH]: {
      value: 13,
      message: 'Your name must have at least 10 characters'
    },
    [FORM_VALIDATION.EMAIL]: 'Please enter a valid email',
  }
},
 */

// import { freeEmailProvidersSet } from '../../../../es6/shared/free-email-providers';

export const FORM_VALIDATION = {
  REQUIRED: 0,
  MIN_LENGTH: 1,
  MAX_LENGTH: 2,
  EMAIL: 3,
  MIN_NUMBER: 4,
  NOT_EMAIL: 5,
  // CORPORATE_EMAIL: 6,
  PHONE_NUMBER: 7,
};

export const EMAIL_REGEXP = /^(?!.*\.\.)[a-zA-Z0-9][a-zA-Z0-9._%+-]*[a-zA-Z0-9]@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/**
 * Source: regex_validator.js.es6
 * @type {RegExp}
 */
export const PHONE_REGEXP = /^\+?\s?[0-9 ()]{8,18}$/gi;

export const matchExact = (r, str) => {
  const match = str.match(r);
  return match && str === match[0];
};

export default {
  data() {
    return {
      form: {},
    };
  },

  computed: {
    values() {
      return this.getNestedObject(this.form, 'value');
    },
    errors() {
      return this.getNestedObject(this.form, 'errors');
    },
  },

  methods: {
    getNestedObject(value, field = 'errors') {
      if (!value) {
        return value;
      }
      if (typeof value[field] !== 'undefined') {
        return value[field];
      }
      return Object.keys(value)
        .reduce((acc, key) => ({
          ...acc,
          [key]: this.getNestedObject(value[key], field),
        }), {});
    },

    validateField(fieldName) {
      this.form[fieldName].errors = [];
      let allValid = true;

      if (this.form[fieldName].value?.trim) {
        this.form[fieldName].value = this.form[fieldName].value.trim();
      }

      const value = this.form[fieldName].value;
      const validation = this.formValidation[fieldName] || {};

      if (validation[FORM_VALIDATION.EMAIL]) {
        const isValid = matchExact(EMAIL_REGEXP, value);
        if (!isValid) {
          this.form[fieldName].errors.push(validation[FORM_VALIDATION.EMAIL]);
          allValid = false;
        }
      }

      if (validation[FORM_VALIDATION.PHONE_NUMBER]) {
        const isValid = matchExact(PHONE_REGEXP, value);
        if (!isValid) {
          this.form[fieldName].errors.push(validation[FORM_VALIDATION.PHONE_NUMBER]);
          allValid = false;
        }
      }

      if (validation[FORM_VALIDATION.NOT_EMAIL]) {
        const isValid = matchExact(EMAIL_REGEXP, value);
        if (isValid) {
          this.form[fieldName].errors.push(validation[FORM_VALIDATION.NOT_EMAIL]);
          allValid = false;
        }
      }

      if (validation[FORM_VALIDATION.MIN_LENGTH]) {
        const isInvalid = value.length < validation[FORM_VALIDATION.MIN_LENGTH].value;
        if (isInvalid) {
          this.form[fieldName].errors.push(validation[FORM_VALIDATION.MIN_LENGTH].message);
          allValid = false;
        }
      }

      if (validation[FORM_VALIDATION.MAX_LENGTH]) {
        const isInvalid = value.length > validation[FORM_VALIDATION.MAX_LENGTH].value;
        if (isInvalid) {
          this.form[fieldName].errors.push(validation[FORM_VALIDATION.MAX_LENGTH].message);
          allValid = false;
        }
      }

      if (validation[FORM_VALIDATION.REQUIRED] && !value) {
        this.form[fieldName].errors.push(validation[FORM_VALIDATION.REQUIRED]);
        allValid = false;
      }

      if (validation[FORM_VALIDATION.MIN_NUMBER]) {
        const isInvalid = parseInt(value, 10) < validation[FORM_VALIDATION.MIN_NUMBER].value;
        if (isInvalid) {
          this.form[fieldName].errors.push(validation[FORM_VALIDATION.MIN_NUMBER].message.replace('{min}', validation[FORM_VALIDATION.MIN_NUMBER].value));
          allValid = false;
        }
      }

      // Not used for now, commenting because of 40KB of domains map in free-emails-providers.js
      // if (validation[FORM_VALIDATION.CORPORATE_EMAIL]) {
      //   const emailDomain = typeof value === 'string' && value.includes('@') ? value.split('@').pop() : '';
      //   const isValid = !freeEmailProvidersSet.has(emailDomain);
      //   if (!isValid) {
      //     this.form[fieldName].errors.push(validation[FORM_VALIDATION.CORPORATE_EMAIL]);
      //     allValid = false;
      //   }
      // }

      allValid = this.customFieldValidate(fieldName) && allValid;
      return allValid;
    },
    customFieldValidate() {
      // To be overwritten in the component
      return true;
    },
    validateFields() {
      let allValid = true;
      Object.keys(this.form).forEach(fieldName => {
        allValid = this.validateField(fieldName) && allValid;
      });
      return allValid;
    },
    saveBackendErrors(backendErrors = {}) {
      Object.keys(backendErrors).forEach(fieldName => {
        if (this.form[fieldName] && this.form[fieldName].errors && backendErrors[fieldName][0].length > 0) {
          this.form[fieldName].errors = backendErrors[fieldName];
        }
      });
    },
    clearErrors() {
      Object.keys(this.form).forEach(fieldName => {
        if (this.form[fieldName] && this.form[fieldName].errors) {
          this.form[fieldName].errors = [];
        }
      });
    },
  },
};
